'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _formSerialize = require('form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _config = require('../utils/config');

var CONFIG = _interopRequireWildcard(_config);

var _uuid = require('../utils/uuid');

var UUID = _interopRequireWildcard(_uuid);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ACL = 'accessControlList';
var BUCKET_NAME = 'bucketName';
var IDENTITY_POOL_ID = 'identityPoolId';
var REGION = 'region';
var schema = exports.schema = {
  id: 's3',
  name: 'S3',
  keys: {
    ACL: ACL,
    BUCKET_NAME: BUCKET_NAME,
    IDENTITY_POOL_ID: IDENTITY_POOL_ID,
    REGION: REGION
  },
  requiredKeys: [ACL, BUCKET_NAME, IDENTITY_POOL_ID, REGION],
  spec: [{
    key: BUCKET_NAME,
    value: ''
  }, {
    key: IDENTITY_POOL_ID,
    value: ''
  }, {
    key: REGION,
    value: ''
  }, {
    key: ACL,
    value: 'public-read'
  }]
};

var hasIntegration = function hasIntegration(config) {
  return !_lodash2.default.isEmpty(CONFIG.getValueForIntegration(config, schema.id, BUCKET_NAME));
};

function withS3(WrappedComponent) {
  var WithS3 = function (_Component) {
    _inherits(WithS3, _Component);

    function WithS3(props) {
      _classCallCheck(this, WithS3);

      var _this = _possibleConstructorReturn(this, (WithS3.__proto__ || Object.getPrototypeOf(WithS3)).call(this, props));

      if (props.config && hasIntegration(props.config)) {
        _this.initS3(props.config);
      }

      return _this;
    }

    _createClass(WithS3, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if (!this.s3 && this.props.config && hasIntegration(this.props.config)) {
          this.initS3(this.props.config);
        }
      }
    }, {
      key: 'initS3',
      value: function initS3(config) {
        var bucket = CONFIG.getValueForIntegration(config, schema.id, BUCKET_NAME);

        if (!this.s3) {
          if (!window.AWS) {
            // eslint-disable-line no-undef
            throw new Error('AWS not found. Please include AWS SDK script, visit https://docs.aws.amazon.com/sdk-for-javascript/v2/developer-guide/loading-the-jssdk.html for more details');
          } else {
            window.AWS.config.update({
              region: CONFIG.getValueForIntegration(config, schema.id, REGION),
              credentials: new window.AWS.CognitoIdentityCredentials({
                IdentityPoolId: CONFIG.getValueForIntegration(config, schema.id, IDENTITY_POOL_ID)
              })
            });
            this.s3 = new window.AWS.S3({
              apiVersion: '2006-03-01',
              params: {
                Bucket: bucket
              }
            });
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return (0, _reactHyperscript2.default)(WrappedComponent, _extends({}, this.props, {
          willSendData: function willSendData(form, formName, componentId, ref) {
            var fileInputs = ref.querySelectorAll('input[type="file"]');

            if (_lodash2.default.some(fileInputs, function (input) {
              return input.getAttribute('required') && !input.files.length;
            })) {
              return false;
            }

            var files = _lodash2.default.reduce(fileInputs, function (result, input) {
              if (input.files.length) {
                // accept single files for now
                return _lodash2.default.concat(result, {
                  file: input.files[0],
                  name: input.getAttribute('name'),
                  required: input.getAttribute('required')
                });
              }

              return result;
            }, []);

            if (!_lodash2.default.isEmpty(files)) {
              return Promise.all(_lodash2.default.map(files, function (_ref) {
                var file = _ref.file,
                    name = _ref.name,
                    required = _ref.required;
                return _this2.s3.upload({
                  Key: UUID.uuidv4() + '-' + file.name,
                  Body: file,
                  ACL: CONFIG.getValueForIntegration(_this2.props.config, schema.id, ACL)
                }).promise().then(function (_ref2) {
                  var Location = _ref2.Location;
                  return Promise.resolve({
                    name: name,
                    location: Location
                  });
                }).catch(function () {
                  if (required) {
                    return Promise.reject(false);
                  }

                  return {};
                });
              })).then(function (uploads) {
                return _lodash2.default.get(_this2.props, 'willSendData', _lodash2.default.identity)(_lodash2.default.reduce(uploads, function (result, upload) {
                  var f = document.createElement('form');
                  var i = document.createElement('input');
                  i.setAttribute('type', 'text');
                  i.setAttribute('name', upload.name);
                  i.setAttribute('value', upload.location);
                  f.appendChild(i);
                  var data = (0, _formSerialize2.default)(f, {
                    hash: true
                  });

                  _lodash2.default.merge(result.data, data);

                  return result;
                }, form), formName, componentId, ref);
              });
            }

            return _lodash2.default.get(_this2.props, 'willSendData', _lodash2.default.identity)(form, formName, componentId, ref);
          }
        }));
      }
    }]);

    return WithS3;
  }(_react.Component);

  WithS3.propTypes = {
    config: _propTypes2.default.shape({
      id: _propTypes2.default.string.isRequired
    })
  };
  WithS3.defaultProps = {
    config: null
  };
  return WithS3;
}

exports.default = {
  apply: withS3,
  hasIntegration: hasIntegration,
  schema: schema
};